import { createFileRoute } from "@tanstack/react-router";

import { DropModerator } from "../features/drop/DropModerator";

/** The moderator canvas, addressed by its mounts. `/<join-code>` reaches the same surface. */
export const Route = createFileRoute("/drop/moderator/$dropMount/$stageMount")({
  component: ModeratorCanvas,
});

function ModeratorCanvas() {
  const { dropMount, stageMount } = Route.useParams();
  return <DropModerator dropMount={dropMount} stageMount={stageMount} />;
}
